// extracted by mini-css-extract-plugin
export var actionButton = "_f7-t";
export var buttonContainer = "_f7-0";
export var buttonContainer2 = "_f7-1";
export var buttonSection = "_f7-2";
export var details = "_f7-3";
export var dropdownItem = "_f7-5";
export var dropdownItemsContainer = "_f7-4";
export var fileInput = "_f7-r";
export var headerButton = "_f7-6";
export var icon = "_f7-7";
export var input = "_f7-8";
export var macroListItem = "_f7-9";
export var mainContent = "_f7-a";
export var microText = "_f7-b";
export var modal = "_f7-w";
export var optionsButton = "_f7-c";
export var paperclip = "_f7-s";
export var pillContent = "_f7-d";
export var preview = "_f7-e";
export var preview2 = "_f7-f";
export var quillEditor = "_f7-q";
export var selectedMacro = "_f7-g";
export var sidebar = "_f7-h";
export var sidebarHeader = "_f7-j";
export var sidebarList = "_f7-i";
export var sidebarListItem = "_f7-k";
export var sidebarSearch = "_f7-l";
export var snoozeDurationWrapper = "_f7-v";
export var statusPillContainer = "_f7-m";
export var tagsContainer = "_f7-n";
export var unselectedMacro = "_f7-o";
export var variable = "_f7-u";
export var wrapper = "_f7-p";